module.exports = __webpack_public_path__ + "static/media/LC.c302915a.png";